export default "__VITE_ASSET__mW7YbeZB__"